import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q5 = [];

var entryPoint = [0, 0];

var selectedCount_Q5 = 0;

var routeMapSet_Q5 = 1;

var newPointDistanceQ5 = 0;

var array1_Q5 = [];

///

var plantArrayQ5 = [[], [], [], [], [], [], []];

var plantLeftArrayQ5 = [[], [], [], [], [], [], [], [], [], []];

///

// var leftFinalRouteMap_Q5 = [new Phaser.Geom.Point(727, 203),new Phaser.Geom.Point(844, 203), new Phaser.Geom.Point(961, 203),new Phaser.Geom.Point(1078, 203)];

///
var leftEntrance_Q5 = new Phaser.Geom.Point(520, -200);

var leftQ5_p1 = new Phaser.Geom.Point(440, 203);
var leftQ5_p2 = new Phaser.Geom.Point(360, 203);
var leftQ5_p3 = new Phaser.Geom.Point(280, 203);
var leftQ5_p4 = new Phaser.Geom.Point(200, 203);
var leftQ5_p5 = new Phaser.Geom.Point(120, 203);
var leftQ5_p6 = new Phaser.Geom.Point(40, 203);

var leftQ5_p7 = new Phaser.Geom.Point(40, 326);
var leftQ5_p8 = new Phaser.Geom.Point(120, 326);
var leftQ5_p9 = new Phaser.Geom.Point(200, 326);

var leftExitWay_Q5 = new Phaser.Geom.Point(200, 900);

var leftFinalRouteMap_Q5 = [leftEntrance_Q5, leftQ5_p1, leftQ5_p2, leftQ5_p3, leftQ5_p4, leftQ5_p5, leftQ5_p6, leftQ5_p7, leftQ5_p8, leftQ5_p9, leftExitWay_Q5];

var leftRouteMapSet_Q5 = 1;

///

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var entrance_Q5 = new Phaser.Geom.Point(0, 0);

var exitWay_Q5 = new Phaser.Geom.Point(0, 0);

var Q5_p1 = new Phaser.Geom.Point(727, 203);
var Q5_p2 = new Phaser.Geom.Point(844, 203);
var Q5_p3 = new Phaser.Geom.Point(961, 203);
var Q5_p4 = new Phaser.Geom.Point(1078, 203);

var Q5_p5 = new Phaser.Geom.Point(727, 326);
var Q5_p6 = new Phaser.Geom.Point(844, 326);
var Q5_p7 = new Phaser.Geom.Point(961, 326);
var Q5_p8 = new Phaser.Geom.Point(1078, 326);

export default class GameSceneQ5 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ5",
    });
  }

  preload() {
    this.load.image("BGQ5", "assets/Q5/BGQ5.png");

    this.load.image("D_BGQ5", "assets/Q5/D_BGQ5.png");
    this.load.image("L_curbQ5", "assets/Q5/L_curbQ5.png");

    this.load.image("hitBoxQ5", "assets/Q5/hitBoxQ5.png");
    this.load.image("curbQ5", "assets/Q5/curbQ5.png");
    this.load.image("rightPlotQ5", "assets/Q5/rightPlotQ5.png");

    this.load.image("leftGreyBoxQ5", "assets/Q5/leftGreyBoxQ5.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    this.BGQ5 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ5");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    ///
    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(-0.2, -0.2).setVisible(false).setDepth(6);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.scoreRefresh();
    ///

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0);

    this.curbQ5 = this.add.sprite(686, 170, "L_curbQ5").setOrigin(0).setDepth(2);
    this.add.sprite(724.7, 203, "rightPlotQ5").setOrigin(0).setDepth(2);

    this.hitBoxQ5_1 = this.add.sprite(727, 203, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ5_2 = this.add.sprite(844, 203, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ5_3 = this.add.sprite(961, 203, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ5_4 = this.add.sprite(1078, 203, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ5_5 = this.add.sprite(727, 323, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ5_6 = this.add.sprite(844, 323, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ5_7 = this.add.sprite(961, 323, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ5_8 = this.add.sprite(1078, 323, "hitBoxQ5").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);

    this.whiteBoxQ5_1 = this.add.sprite(726, 205, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ5_2 = this.add.sprite(843.5, 205, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ5_3 = this.add.sprite(961, 205, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ5_4 = this.add.sprite(1078, 205, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);

    this.whiteBoxQ5_5 = this.add.sprite(726, 325, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ5_6 = this.add.sprite(843.5, 325, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ5_7 = this.add.sprite(961, 325, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ5_8 = this.add.sprite(1078, 325, "whiteBoxQ5").setOrigin(0).setVisible(false).setDepth(2);

    ///

    this.leftGreyBoxQ5 = this.add.sprite(88, 206, "leftGreyBoxQ5").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    // this.Q5_ans = this.add.sprite(654.14,474.2, "qnBoard").setOrigin(0);

    this.Q5_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q5_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0);

    this.Q5_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q5_leftDr = this.add.text(78, 578, "12", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q5_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q5_rightDr = this.add.text(715, 578, "8", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.5, 0.5).setDepth(6);
    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    ///

    ///

    this.anims.create({
      key: "floweringQ5",
      frames: this.anims.generateFrameNames("flowering2Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "Flower",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    //>1

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();

    //<1

    ///
    this.waterPlantOnLeftQ5();

    // this.startQuestionQ5();
  }

  //   showCircles(){

  //     var graphics = this.add.graphics();

  //     graphics.fillStyle(0xff0000, 1);

  //     graphics.fillCircle(Q5_p1.x, Q5_p1.y, 4);
  //     graphics.fillCircle(Q5_p2.x, Q5_p2.y, 4);
  //     graphics.fillCircle(Q5_p3.x, Q5_p3.y, 4);
  //     graphics.fillCircle(Q5_p4.x, Q5_p4.y, 4);
  //     graphics.fillCircle(Q5_p5.x, Q5_p5.y, 4);
  //     graphics.fillCircle(Q5_p6.x, Q5_p6.y, 4);
  //     graphics.fillCircle(Q5_p7.x, Q5_p7.y, 4);
  //     graphics.fillCircle(Q5_p8.x, Q5_p8.y, 4);
  //     graphics.fillCircle(Q5_p9.x, Q5_p9.y, 4);
  //     graphics.fillCircle(Q5_p10.x, Q5_p10.y, 4);
  // }

  ///
  waterPlantOnLeftQ5() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ5.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q5[0].x, leftFinalRouteMap_Q5[0].y, leftFinalRouteMap_Q5[1].x, leftFinalRouteMap_Q5[1].y);
      },
      [],
      this
    );
  }

  startQuestionQ5() {
    //>//>>>hidden_console.log("startQ5");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  ////////

  // moveCanInitial(fromX, fromY, toX, toY){

  //   this.time.delayedCall(1800, () => {
  //     this.waterThePlant(0);
  //   // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

  //   // this.createPlants(leftFinalRouteMap_Q5[leftRouteMapSet_Q5-1],leftRouteMapSet_Q5-1);

  //   },[],this);

  //   this.time.delayedCall(1000, () => {

  //     this.createLeftPlants(leftFinalRouteMap_Q5[leftRouteMapSet_Q5-1],leftRouteMapSet_Q5-1);
  //   },[],this);

  //   this.tweens.add({
  //     targets: this.can,
  //     duration: 1500,
  //     ease: 'Cubic',
  //     delay: 500,
  //     yoyo: false,
  //     x: {from:fromX, to:toX},
  //     y: {from:fromY, to:toY},
  //     completeDelay:500,
  //     onComplete: () => {

  //       if(leftRouteMapSet_Q5 < leftFinalRouteMap_Q5.length - 1){
  //         this.Q5_leftNr.setText(leftRouteMapSet_Q5);

  //         this.moveCanInitial(leftFinalRouteMap_Q5[leftRouteMapSet_Q5].x,leftFinalRouteMap_Q5[leftRouteMapSet_Q5].y,leftFinalRouteMap_Q5[leftRouteMapSet_Q5 + 1].x,leftFinalRouteMap_Q5[leftRouteMapSet_Q5 + 1].y)

  //         leftRouteMapSet_Q5 = leftRouteMapSet_Q5 + 1;
  //         //>//>>>hidden_console.log(leftRouteMapSet_Q5);
  //       }
  //       else{
  //         this.Q5_leftNr.setVisible(true);
  //         this.Q5_input.setVisible(true);

  //         this.startQuestionQ5();
  //       }
  //     },
  //     onCompleteScope:this
  // })
  // }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      900,
      () => {
        this.waterTheLeftPlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q5[leftRouteMapSet_Q5-1],leftRouteMapSet_Q5-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      500,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q5[leftRouteMapSet_Q5 - 1], leftRouteMapSet_Q5 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 750,
      ease: "Cubic",
      delay: 250,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 250,
      onComplete: () => {
        if (leftRouteMapSet_Q5 < leftFinalRouteMap_Q5.length - 1) {
          this.Q5_leftNr.setText(leftRouteMapSet_Q5);

          this.moveCanInitial(leftFinalRouteMap_Q5[leftRouteMapSet_Q5].x, leftFinalRouteMap_Q5[leftRouteMapSet_Q5].y, leftFinalRouteMap_Q5[leftRouteMapSet_Q5 + 1].x, leftFinalRouteMap_Q5[leftRouteMapSet_Q5 + 1].y);

          leftRouteMapSet_Q5 = leftRouteMapSet_Q5 + 1;
          //>//>>>hidden_console.log(leftRouteMapSet_Q5);
        } else {
          this.Q5_leftNr.setVisible(true);
          this.Q5_input.setVisible(true);

          this.startQuestionQ5();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ5.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ5[k5].length; l5++) {
        plantLeftArrayQ5[k5][l5].setTexture("flowering2Anim").play("floweringQ5");

        //>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ5[1][1].setTexture("flowering2Anim").play("floweringQ5");

    for (var k = 0; k < plantArrayQ5.length; k++) {
      for (var l = 0; l < plantArrayQ5[k].length; l++) {
        plantArrayQ5[k][l].setTexture("flowering2Anim").play("floweringQ5");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ5");
    //   this.scene.start('GameSceneQ6');

    // },[],this);

    this.removeClicking();
    this.changeScene();
  }

  changeScene() {
    //>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();
            attempts = 0;

            this.wipeSceneQ5();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ5");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ5");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ5");
              this.scene.start("GameSceneQ6");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        if (gameState.attempted == 10) {
          gameState.gameWin = false;
          // this.scene.stop("TutorialScene");
          this.scene.start("EndScene");
        }
      },
      [],
      this
    );
  }

  wipeSceneQ5() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q5 = [];

    entryPoint = [0, 0];

    selectedCount_Q5 = 0;

    routeMapSet_Q5 = 1;

    newPointDistanceQ5 = 0;

    plantArrayQ5 = [[], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ5 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q5 = [leftEntrance_Q5,leftQ5_p1,leftExitWay_Q5];
    leftRouteMapSet_Q5 = 1;

    entrance_Q5.setTo(0, 0);

    exitWay_Q5.setTo(0, 0);
    array1_Q5 = [];
  }

  ///

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q5 += 1;

      this.Q5_input.setText(selectedCount_Q5);
    } else {
      hitboxname.setAlpha(0.1);

      // this.updateRouteMap(xcode,ycode);

      Phaser.Utils.Array.Remove(array1_Q5, this.getPointFromCode(xcode, ycode));

      selectedCount_Q5 -= 1;
      this.Q5_input.setText(selectedCount_Q5);

      //>//>>>hidden_console.log(finalRouteMap_Q5);
    }
  }

  // removeUnselected(xcode,ycode){
  //   Phaser.Utils.Array.Remove(finalRouteMap_Q5,this.getPointFromCode(xcode,ycode));
  // }

  updateRouteMap(xcode, ycode) {
    array1_Q5.push(this.getPointFromCode(xcode, ycode));
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q5_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q5_p2;
    } else if (xcode == 2 && ycode == 0) {
      return Q5_p3;
    } else if (xcode == 3 && ycode == 0) {
      return Q5_p4;
    } else if (xcode == 0 && ycode == 1) {
      return Q5_p5;
    } else if (xcode == 1 && ycode == 1) {
      return Q5_p6;
    } else if (xcode == 2 && ycode == 1) {
      return Q5_p7;
    } else if (xcode == 3 && ycode == 1) {
      return Q5_p8;
    }
  }

  scoreRefresh() {
    //>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    //>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  pathFinding() {
    finalRouteMap_Q5.push(array1_Q5[0]);

    array1_Q5.splice(0, 1);

    ////>//>>>hidden_console.log(array1_Q5)

    for (let i = 0; i < finalRouteMap_Q5.length; i++) {
      var distanceArray = [];
      for (let j = 0; j < array1_Q5.length; j++) {
        // var dist = Math.sqrt(Math.pow(finalRouteMap_Q5[i][0] - array1_Q5[j][0], 2) + Math.pow(finalRouteMap_Q5[i][1] - array1_Q5[j][1], 2));
        var dist = Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q5[i], array1_Q5[j]);
        distanceArray.push(dist);
      }
      var index = distanceArray.indexOf(Math.min(...distanceArray));

      finalRouteMap_Q5.push(array1_Q5[index]);
      array1_Q5.splice(index, 1);
      //>//>>>hidden_console.log(finalRouteMap_Q5);

      if (finalRouteMap_Q5.length == 6) {
        break;
      }
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();

      // this.moveCan(routeMap[0][0],routeMap[0][1],routeMap[1][0],routeMap[1][1]);

      if (selectedCount_Q5 == 6) {
        this.pathFinding();

        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        //>2

        this.hintButton.removeInteractive();
        this.hideDeselect();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        //>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q5_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q5[0] == Q5_p1) {
          entrance_Q5.setTo(727, -200);
        } else if (finalRouteMap_Q5[0] == Q5_p2) {
          entrance_Q5.setTo(844, -200);
        } else if (finalRouteMap_Q5[0] == Q5_p3) {
          entrance_Q5.setTo(961, -200);
        } else if (finalRouteMap_Q5[0] == Q5_p4) {
          entrance_Q5.setTo(2078, 203);
        } else if (finalRouteMap_Q5[0] == Q5_p5) {
          entrance_Q5.setTo(727, 900);
        } else if (finalRouteMap_Q5[0] == Q5_p6) {
          entrance_Q5.setTo(844, 900);
        } else if (finalRouteMap_Q5[0] == Q5_p7) {
          entrance_Q5.setTo(961, 900);
        } else if (finalRouteMap_Q5[0] == Q5_p8) {
          entrance_Q5.setTo(2078, 326);
        }

        finalRouteMap_Q5.unshift(entrance_Q5);

        if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p1) {
          exitWay_Q5.setTo(727, -200);
        } else if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p2) {
          exitWay_Q5.setTo(844, -200);
        } else if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p3) {
          exitWay_Q5.setTo(961, -200);
        } else if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p4) {
          exitWay_Q5.setTo(2078, 203);
        } else if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p5) {
          exitWay_Q5.setTo(727, 900);
        } else if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p6) {
          exitWay_Q5.setTo(844, 900);
        } else if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p7) {
          exitWay_Q5.setTo(961, 900);
        } else if (finalRouteMap_Q5[finalRouteMap_Q5.length - 1] == Q5_p8) {
          exitWay_Q5.setTo(2078, 326);
        }

        finalRouteMap_Q5.push(exitWay_Q5);

        this.moveCan(finalRouteMap_Q5[0].x, finalRouteMap_Q5[0].y, finalRouteMap_Q5[1].x, finalRouteMap_Q5[1].y);
      } else {
        config.audio.wrongAnswer.play();

        //>3

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3

        // this.Q5_ans.setTint(0xFFC2A2);

        this.Q5_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q5_rightDr.setFill("#C22300");
        this.Q5_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q5_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q5_rightDr.setFill("#2b2b2b");
            this.Q5_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }

  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }

    //>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    // this.getPositionCodeFromCoordinates(fromX,toX);

    // //>//>>>hidden_console.log(this.getPositionCodeFromCoordinates(fromX,fromY));

    // //>//>>>hidden_console.log(this.calculateDistance())

    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(finalRouteMap_Q5[routeMapSet_Q5-1],routeMapSet_Q5-1);
      },
      [],
      this
    );

    ///////

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap_Q5[routeMapSet_Q5 - 1], routeMapSet_Q5 - 1);
      },
      [],
      this
    );

    ///////

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet_Q5 < finalRouteMap_Q5.length - 1) {
          this.moveCan(finalRouteMap_Q5[routeMapSet_Q5].x, finalRouteMap_Q5[routeMapSet_Q5].y, finalRouteMap_Q5[routeMapSet_Q5 + 1].x, finalRouteMap_Q5[routeMapSet_Q5 + 1].y);

          routeMapSet_Q5 = routeMapSet_Q5 + 1;
          //>//>>>hidden_console.log(routeMapSet_Q5);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
        //////
      },
      onCompleteScope: this,
    });
  }
  showDeselect() {
    if (selectedCount_Q5 >= 6) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(array1_Q5[0].x, array1_Q5[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  //no need to relook functions

  hitboxClickAndHoverHandle() {
    this.BGQ5.setTexture("BGQ5");
    this.curbQ5.setTexture("curbQ5");

    this.hitBoxQ5_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_1, 0, 0);
      },
      this
    );
    this.hitBoxQ5_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_2, 1, 0);
      },
      this
    );
    this.hitBoxQ5_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_3, 2, 0);
      },
      this
    );
    this.hitBoxQ5_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_4, 3, 0);
      },
      this
    );
    this.hitBoxQ5_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_5, 0, 1);
      },
      this
    );
    this.hitBoxQ5_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_6, 1, 1);
      },
      this
    );
    this.hitBoxQ5_7.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_7, 2, 1);
      },
      this
    );
    this.hitBoxQ5_8.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ5_8, 3, 1);
      },
      this
    );

    this.hitBoxQ5_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(1);
      },
      this
    );
    this.hitBoxQ5_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(2);
      },
      this
    );
    this.hitBoxQ5_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(3);
      },
      this
    );
    this.hitBoxQ5_4.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(4);
      },
      this
    );
    this.hitBoxQ5_5.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(5);
      },
      this
    );
    this.hitBoxQ5_6.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(6);
      },
      this
    );
    this.hitBoxQ5_7.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(7);
      },
      this
    );
    this.hitBoxQ5_8.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ5(8);
      },
      this
    );

    this.hitBoxQ5_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
    this.hitBoxQ5_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
    this.hitBoxQ5_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
    this.hitBoxQ5_4.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
    this.hitBoxQ5_5.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
    this.hitBoxQ5_6.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
    this.hitBoxQ5_7.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
    this.hitBoxQ5_8.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ5();
      },
      this
    );
  }

  ///

  enableClicking() {
    this.hitBoxQ5_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ5_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ5_3.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ5_4.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ5_5.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ5_6.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ5_7.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ5_8.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  removeClicking() {
    this.hitBoxQ5_1.removeInteractive();
    this.hitBoxQ5_2.removeInteractive();
    this.hitBoxQ5_3.removeInteractive();
    this.hitBoxQ5_4.removeInteractive();
    this.hitBoxQ5_5.removeInteractive();
    this.hitBoxQ5_6.removeInteractive();
    this.hitBoxQ5_7.removeInteractive();
    this.hitBoxQ5_8.removeInteractive();

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }

    this.hintButton.removeInteractive();
  }

  ///

  showWhiteBoxQ5(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ5();
    if (position == 1) {
      this.whiteBoxQ5_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ5_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ5_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBoxQ5_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBoxQ5_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBoxQ5_6.setVisible(true);
    }
    if (position == 7) {
      this.whiteBoxQ5_7.setVisible(true);
    }
    if (position == 8) {
      this.whiteBoxQ5_8.setVisible(true);
    }
  }

  removeWhiteBoxQ5() {
    this.whiteBoxQ5_1.setVisible(false);
    this.whiteBoxQ5_2.setVisible(false);
    this.whiteBoxQ5_3.setVisible(false);
    this.whiteBoxQ5_4.setVisible(false);
    this.whiteBoxQ5_5.setVisible(false);
    this.whiteBoxQ5_6.setVisible(false);
    this.whiteBoxQ5_7.setVisible(false);
    this.whiteBoxQ5_8.setVisible(false);
  }

  createPlants(selectedPoint, plantSelectionCode) {
    plantArrayQ5[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x + 30, selectedPoint.y + 20, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArrayQ5[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x + 75, selectedPoint.y + 20, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);

    plantArrayQ5[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 60, selectedPoint.y + 50, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArrayQ5[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x + 105, selectedPoint.y + 50, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
  }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    plantLeftArrayQ5[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x + 25, selectedPoint.y + 20, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false);
    plantLeftArrayQ5[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x + 70, selectedPoint.y + 20, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");

    plantLeftArrayQ5[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 60, selectedPoint.y + 50, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false);
    plantLeftArrayQ5[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x + 110, selectedPoint.y + 50, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding");
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q5 <= selectedCount_Q5 || leftRouteMapSet_Q5 < leftFinalRouteMap_Q5.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");

            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  waterTheLeftPlant(flowingtime) {
    if (routeMapSet_Q5 <= selectedCount_Q5 || leftRouteMapSet_Q5 < leftFinalRouteMap_Q5.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      500,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");

            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
